import { render } from "./BillingPage.vue?vue&type=template&id=6cb03c0e"
import script from "./BillingPage.vue?vue&type=script&lang=js"
export * from "./BillingPage.vue?vue&type=script&lang=js"

import "@/assets/styles/billing/billingPage.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__